import { Home, About, Contact, Projects, Header } from './compontents/index'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/projects' element={<Projects />} />
        </Routes>
        
      </div>
    </Router>
  );
}

export default App
